import { useEffect, useMemo } from 'react';

import { AnalyticsContext } from './analytics-context';
import { PostHogAdapter } from './posthog-adapter';
import { AnalyticsProviderProps } from './types';

const AnalyticsProvider = ({ children, apiKey, host }: AnalyticsProviderProps) => {
  const adapter = useMemo(() => new PostHogAdapter({ apiKey, host }), [apiKey, host]);

  useEffect(() => {
    adapter.init();
  }, [adapter]);

  const contextValue = useMemo(() => ({ adapter }), [adapter]);

  return <AnalyticsContext.Provider value={contextValue}>{children}</AnalyticsContext.Provider>;
};

export { AnalyticsProvider };
export type { AnalyticsProviderProps };
